// Imports
import PropTypes from 'prop-types'
import API from '../../../utils/http/api'

// Actions
const RETRIEVE_QUESTIONS_REQUEST = 'steppingblocks/personalityAssessment/RETRIEVE_QUESTIONS_REQUEST'
const RETRIEVE_QUESTIONS_SUCCESS = 'steppingblocks/personalityAssessment/RETRIEVE_QUESTIONS_SUCCESS'
const RETRIEVE_QUESTIONS_FAILURE = 'steppingblocks/personalityAssessment/RETRIEVE_QUESTIONS_FAILURE'
const SUBMIT_ANSWERS_REQUEST = 'steppingblocks/personalityAssessment/SUBMIT_ANSWERS_REQUEST'
const SUBMIT_ANSWERS_SUCCESS = 'steppingblocks/personalityAssessment/SUBMIT_ANSWERS_SUCCESS'
const SUBMIT_ANSWERS_FAILURE = 'steppingblocks/personalityAssessment/SUBMIT_ANSWERS_FAILURE'
const RETRIEVE_RESULTS_REQUEST = 'steppingblocks/personalityAssessment/RETRIEVE_RESULTS_REQUEST'
const RETRIEVE_RESULTS_SUCCESS = 'steppingblocks/personalityAssessment/RETRIEVE_RESULTS_SUCCESS'
const RETRIEVE_RESULTS_FAILURE = 'steppingblocks/personalityAssessment/RETRIEVE_RESULTS_FAILURE'
const RESET = 'steppingblocks/personalityAssessment/RESET'
const NEXT_QUESTION = 'steppingblocks/personalityAssessment/NEXT_QUESTION'
const PREVIOUS_QUESTION = 'steppingblocks/personalityAssessment/PREVIOUS_QUESTION'

// Reducer
const initialState = {
  retrieveQuestions: {
    error: null,
    requestStarted: false,
    requestEnded: false,
  },
  submitAnswers: {
    error: null,
    requestStarted: false,
    requestEnded: false,
  },
  retrieveResults: {
    error: null,
    requestStarted: false,
    requestEnded: false,
  },
  activeQuestionIndex: 0,
  questions: [],
  answers: [],
  result: null,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case RETRIEVE_QUESTIONS_REQUEST:
      return {
        ..._state,
        retrieveQuestions: {
          error: null,
          requestStarted: true,
          requestEnded: false,
        },
      }
    case RETRIEVE_QUESTIONS_SUCCESS:
      return {
        ..._state,
        retrieveQuestions: {
          error: null,
          requestStarted: true,
          requestEnded: true,
        },
        questions: payload.questions,
      }
    case RETRIEVE_QUESTIONS_FAILURE:
      return {
        ..._state,
        retrieveQuestions: {
          error: payload.error,
          requestStarted: true,
          requestEnded: true,
        },
      }
    case SUBMIT_ANSWERS_REQUEST:
      return {
        ..._state,
        submitAnswers: {
          error: null,
          requestStarted: true,
          requestEnded: false,
        },
      }
    case SUBMIT_ANSWERS_SUCCESS:
      return {
        ..._state,
        retrieveQuestions: {
          error: null,
          requestStarted: true,
          requestEnded: true,
        },
        result: payload.result,
      }
    case SUBMIT_ANSWERS_FAILURE:
      return {
        ..._state,
        submitAnswers: {
          error: payload.error,
          requestStarted: true,
          requestEnded: true,
        },
      }
    case RETRIEVE_RESULTS_REQUEST:
      return {
        ..._state,
        retrieveResults: {
          error: null,
          requestStarted: true,
          requestEnded: false,
        },
      }
    case RETRIEVE_RESULTS_SUCCESS:
      return {
        ..._state,
        retrieveResults: {
          error: null,
          requestStarted: true,
          requestEnded: true,
        },
        result: payload.result,
      }
    case RETRIEVE_RESULTS_FAILURE:
      return {
        ..._state,
        retrieveResults: {
          error: payload.error,
          requestStarted: true,
          requestEnded: true,
        },
      }
    case NEXT_QUESTION: // eslint-disable-line
      const newAnswers = _state.answers
      newAnswers[_state.activeQuestionIndex] = payload.answer

      return {
        ..._state,
        activeQuestionIndex: _state.activeQuestionIndex + 1,
        answers: newAnswers,
      }
    case PREVIOUS_QUESTION:
      return {
        ..._state,
        activeQuestionIndex: _state.activeQuestionIndex - 1,
      }
    case RESET:
      return {
        ...initialState,
        questions: _state.questions,
      }
    default:
      return _state
  }
}

// Action Performers
export const resetPersonalityAssessment = () => ({
  type: RESET,
})

export const goToNextQuestion = answer => ({
  type: NEXT_QUESTION,
  payload: {
    answer,
  },
})

export const goToPreviousQuestion = () => ({
  type: PREVIOUS_QUESTION,
})

export const performRetrievePersonalityAssessmentQuestions = () => async dispatch => {
  dispatch({ type: RETRIEVE_QUESTIONS_REQUEST })
  try {
    const data = await API.get('/personality/questions')
    dispatch({
      type: RETRIEVE_QUESTIONS_SUCCESS,
      payload: {
        questions: data.questions,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: RETRIEVE_QUESTIONS_FAILURE,
      payload: { error: error.message },
    })
    return error
  }
}

export const performAnalyzePersonalityAssessmentAnswers = answers => async dispatch => {
  dispatch({ type: SUBMIT_ANSWERS_REQUEST })
  try {
    const data = await API.post('/personality/questions', { answers })
    dispatch({
      type: SUBMIT_ANSWERS_SUCCESS,
      payload: {
        result: data.result,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: SUBMIT_ANSWERS_FAILURE,
      payload: {
        error: error.message,
      },
    })
    return error
  }
}

export const getPersonalityAssessmentResultsForUser = () => async dispatch => {
  dispatch({ type: RETRIEVE_RESULTS_REQUEST })
  try {
    const data = await API.get('/personality')
    dispatch({
      type: RETRIEVE_RESULTS_SUCCESS,
      payload: {
        result: data.result,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: RETRIEVE_RESULTS_FAILURE,
      payload: {
        error: error.message,
      },
    })
    // throw new Error(error)
  }
}

// PropTypes
export const propTypes = PropTypes.shape({})

//
// Fixtures
export const testData = {}



// WEBPACK FOOTER //
// ./src/routes/authenticated/PersonalityAssessment/personalityAssessmentDuck.js